import { useEffect, useState } from "react";

// Implementation from https://github.com/chakra-ui/chakra-ui/issues/3580#issuecomment-1131211586
const useMediaQuery = (mediaQueryString: string) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(mediaQueryString);
        const listener = () => setMatches(!!mediaQueryList.matches);
        listener();
        mediaQueryList.addEventListener("change", listener);
        return () => mediaQueryList.removeEventListener("change", listener);
    }, [mediaQueryString]);

    return matches;
};

export default useMediaQuery;
